import {axiospost,axiosget} from './axios';


export const admin = {
    // 退出登陆
    loginout:()=>{
        return axiospost ('/sys/logout',{})
    },
    //修改个人信息
    editmyinfor:(upobj)=>{
        return axiospost ('/sys/user/editMyData',upobj)
    },
    //修改密码
    changepassword:(userId,password,oldPassword)=>{
        return axiospost ('/sys/user/changPassword',{
            userId:userId,
            password:password,
            oldPassword:oldPassword
        })
    },
    //消息弹窗  /sys/Notification/getAlertNotification
    getnoticeModel: ()=> {
        return axiosget ('/sys/Notification/getAlertNotification',{}); 
    },
    //消息列表  /sys/Notification/getNotification
    getnoticeList: (upobj)=> {
        return axiosget ('/sys/Notification/getNotification',upobj); 
    },
    changenoticeStatue:(id) =>{
        return axiospost ('/sys/Notification/setNotificationReaded',{id:id});
    },
    delnotice:(id)=>{
        return axiospost ('/sys/Notification/delNotification',{id:id});
    },
    // 用户管理
    getCuserList: (updata)=> {
        return axiosget ('/sys/personalUser/list',updata); 
    },
    userFrozen:(userId,userName,userStatus,roleCode)=>{
        return axiospost ('/sys/user/frozen',{
            userId:userId,
            userStatus:userStatus,
            userName:userName,
            roleCode:roleCode
        }); 
    },
    //  企业管理
    getCompanylist: (pageNo,pageSize,name,createDateBegin,createDateEnd,abbreviation,companyType)=> {
        return axiosget ('/sys/tdeconomiccompany/list',{
            pageNo:pageNo,
            pageSize:pageSize,
            name:name,
            createDateBegin:createDateBegin,
            createDateEnd:createDateEnd,
            abbreviation:abbreviation,
            companyType:companyType
        }); 
    },
    companySelect:()=>{
        return axiosget('/sys/tdeconomiccompany/listNotPage',{})
    },
    getCompanyInfor: (id)=> {
        return axiosget ('/sys/tdeconomiccompany/first',{
            id:id
        }); 
    },
    delCompany: (id)=> {
        return axiospost ('/sys/tdeconomiccompany/del',{
            companyId:id
        }); 
    },
    editCompanyAccess: (id,name,registration_number,legal_person,legal_card,open_startdate,open_enddate,open_type,business_license,cardimg,authimg,abbreviation,company_type,phone,unifiedsocialcreditcode,address) =>{
        return axiospost ('/sys/tdeconomiccompany/edit',{
            companyId:id,
            name:name,
            registrationNumber:registration_number,
            legalPerson:legal_person,
            legalCard:legal_card,
            openStartdate:open_startdate,
            openEnddate:open_enddate,
            openType:open_type,
            businessLicense:business_license,
            cardimg:cardimg,
            authimg:authimg,
            abbreviation:abbreviation,
            companyType:company_type,
            phone:phone,
            unifiedsocialcreditcode:unifiedsocialcreditcode,
            address:address
        });
    },
    createCompanyAccess: function(name,registration_number,legal_person,legal_card,open_startdate,open_enddate,open_type,business_license,cardimg,authimg,abbreviation,company_type,phone,unifiedsocialcreditcode,address){
        const params = {name:name,
            registrationNumber:registration_number,
            legalPerson:legal_person,
            legalCard:legal_card,
            openStartdate:open_startdate,
            openEnddate:open_enddate,
            openType:open_type,
            businessLicense:business_license,
            cardimg:cardimg,
            authimg:authimg,
            abbreviation:abbreviation,
            companyType:company_type,
            phone:phone,
            unifiedsocialcreditcode:unifiedsocialcreditcode,
            address:address
        }
        return axiospost ('/sys/tdeconomiccompany/add',params);
    },
    getEnterPriseList: function(enterpriseName,pageSize){
        return axiosget ('/sys/enterpriseApply/enterpriseList?enterpriseName=' + enterpriseName + '&pageSize=' + pageSize);
    },

    // 门店管理
    getstoreList: (pageNo,pageSize,companyName,storeName,createDateBegin,createDateEnd,companyID) => {
        return axiosget ('/sys/tdstoreinfo/list',{
            companyName:companyName,
            storeName:storeName,
            createDateBegin:createDateBegin,
            createDateEnd:createDateEnd,
            companyID:companyID,
            pageNo:pageNo,
            pageSize:pageSize,
        }); 
    },
    //帐号管理
    creatAccount:(upobj) =>{
        return axiospost('/sys/user/add',upobj)
    },
    getaccountlist:(updata) =>{
        return axiosget('/sys/user/list',updata)
    },
    getaccountInfor:(id)=>{
        return axiosget('/sys/user/queryById',{
            userId:id
        })
    },
    getaccountEvaluate:(id) =>  {
        return axiosget('/sys/user/queryUserScore',{userId:id})
    },
    repassword:(userId)=>{
        return axiospost('/sys/user/resetPassword',{userId:userId})
    },
    getstoreselect:(id)=>{
        return axiosget ('/sys/tdstoreinfo/listNotPage',{companyId:id}); 
    },
    
    //角色管理
    getroleselect: ()=> {
        return axiosget ('/sys/role/listSelect',{}); 
    },
    delrole:(id)=>{
        return axiospost ('/sys/role/delete',{id:id});
    },
    addrole:(role,permissionIds)=>{
        return axiospost('/sys/role/add',{role:role,permissionIds:permissionIds})
    },
    editrole:(role,permissionIds)=>{
        return axiospost('/sys/role/edit',{role:role,permissionIds:permissionIds})
    },
    getroleInfor:(id)=>{
        return axiosget('/sys/role/queryById',{roleId:id})
    },
    getroleList:(p,psize)=>{
        return axiosget ('/sys/role/list',{pageNo:p,pageSize:psize}); 
    },
    //系统设置
    getsystem:()=>{
        return axiosget ('/sys/ts-settings/getSysSettings',{}); 
    },
    setsystem:(upobj)=>{
        return axiospost ('/sys/ts-settings/updateSysSettings',upobj); 
    },
    // 房源管理
    gethouselist:(upobj)=>{
        return axiosget ('/sys/housemanager/list',upobj); 
    },
    downhouse:(upobj) => {
        return axiosget ('/sys/housemanager/setState',upobj); 
    },
    gethouseInfor:(upobj)=>{
        return axiosget ('/sys/housemanager/first',upobj); 
    },
    yjdownhouse:(upobj) =>{//悦居管理员一键下线
        return axiospost ('/sys/myhouse/updateoff',upobj); 
    },
    submitzhuanpai:(upobj) =>{//悦居管理员转派房源
        return axiospost ('/sys/myhouse/zhuanPai',upobj); 
    },
    deleteAdmin:(upobj) =>{//账号注销
        return axiospost ('/sys/user/delete',upobj); 
    }
  }